// eslint-disable-next-line no-control-regex
const ANSI_ESCAPE_PATTERN = /\x1b\[[0-9;]*m/g;

export function truncateErrorMessage(message: string, maxLength = 150): string {
  const cleaned = message.replace(ANSI_ESCAPE_PATTERN, '').replace(/\s+/g, ' ').trim();

  if (cleaned.length <= maxLength) return cleaned;
  return `${cleaned.slice(0, maxLength).trimEnd()}…`;
}
